import React from "react";
import Typography from "@mui/material/Typography";
import {CardWithImageAndText} from "./CardWithImageAndText";
import divinoNino from "../../assets/discover-the-city/divinonino.webp";
import fresas from "../../assets/discover-the-city/FRESAS_ARIYAMA.webp";
import piedrasLetradas from  "../../assets/discover-the-city/piedras-letradas.webp";
import reservaEbanoVerde from "../../assets/discover-the-city/reserva-ebano-verde.webp";
import saltoAguasBlancas from "../../assets/discover-the-city/salto-aguas-blancas.webp";
import valleNuevo from "../../assets/discover-the-city/valle-nuevo.webp";

const DiscoverTheCity = () => {
    const places = [
        {
            image: divinoNino,
            title: "Divino Niño",
            description: "A 13 minutos del projecto se encuentra una gigantesca estatua del Divino Niño, hecha a mano, de unos 15 metros de altura, diseñada por el escultor Ramón Osorio, en el 2011.",
            alt: "Estatua del Divino Niño",
            id: 'divino-nino'
        },
        {
            image: fresas,
            title: "Fresas Ariyama",
            description: "A 18 minutos del projecto, Fresas Ariyama es una plantación de fresas. Fresas Ariyama es un lugar popular para los turistas que visitan la ciudad.",
            alt: "Fresas Ariyama",
            id: 'fresas-ariyama'
        },
        {
            image: piedrasLetradas,
            title: "Piedras Letradas",
            description: "A 40 minutos del projecto se encuentra Las Piedras Letradas un monolito de piedra sobre cuya superficie, los aborígenes escribieron sus creencias, en el lenguaje taino.",
            alt: "Piezas Letradas",
            id: 'piedras-letradas'
        },
        {
            image: reservaEbanoVerde,
            title: "Reserva Científica Ébano Verde",
            description: "La Científica Reserva Ebano Verde es un área protegida conocida por su diversidad biológica, y el elevado endemismo de su flora y fauna.",
            alt: "Reserva Científica Ébano Verde",
            id: "ebano-verde"
        },
        {
            image: saltoAguasBlancas,
            title: "Salto Aguas Blancas",
            description: "El Salto Aguas Blancas está ubicada en una meseta, una de las más altas en el Caribe, cae unos 83 metros hasta una gran piscina fría color jade abrazada por un terreno cubierto de altos pinos y árboles de ébano verde",
            alt: "Salto Aguas Blancas",
            id: "salto-aguas-blancas"
        },
        {
            image: valleNuevo,
            title: "Valle Nuevo",
            description: "Valle Nuevo es conocido por ofrecer excepcionales oportunidades para la observación de aves y senderismo de montaña, Valle Nuevo es una de las joyas de la corona de Constanza.",
            alt: "Valle Nuevo",
            id: "valle-nuevo"
        }
    ];



    return (
        <div className="city-hightlights" id='descubre-constanza'>
            <Typography variant="h3" sx={{color: "var(--primary-color)", fontSize: '30px', fontWeight: 'bold', marginY: '40px', textTransform: 'uppercase'}} className='section-title'>Descubre la ciudad de Constanza</Typography>

            <div className="cards-with-text">
                {places.map((place) => (
                    <CardWithImageAndText image={place.image} title={place.title} description={place.description} key={place.id} alt={place.alt}/>
                ))}
            </div>
        </div>
    );
}

export default DiscoverTheCity;
